var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('feather-icon',{attrs:{"icon":"ArrowRightIcon","svgClasses":"h-5 w-5 hover:text-primary cursor-pointer"},on:{"click":_vm.goToSetting}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }